<template>
<div>
    <h3 class="mt-3">{{index + 1}} - {{question.translation.name}}</h3>
    <span
        v-if="question.translation.description"
        v-html="question.translation.description"
        class="mb-3 d-block"
    />
    <fieldset
        :id="`question_id-${question.id}`"
        :class="{ verifyValidate: verifyValidate && error.has('option')}"
        class="p-1"
    >
        <label
            v-for="option in question.options"
            @mouseover="!isFinished ? onMouseOver(option.id): false"
            @mouseleave="onMouseLeave()"
            :key="option.id"
            :id="`question_id-${question.id}`"
            :style="[
                visualFeedback(option),
                hoverAnimation(color.primary, option.id),
                (model === option.id) && !exercise.show_answer ? onSelected(color.primary) : ''
            ]"
            class="btn-group d-flex my-3 justify-content-between align-items-center"
        >
            <input
                v-model="model"
                @change="submitOption"
                :name="`option-${option.name}`"
                :value="option.id"
                :id="option.id"
                :disabled="isDisabled(option.id)"
                class="mr-3 custom-control-input"
                v-validate="'required'"
                data-vv-name="option"
                type="radio"
            />

            <div>{{option.name}}</div>

            <span
                v-if="model === option.id"
                :style="`color:${color.primary}`"
                class="material-icons"
            >
                radio_button_checked
            </span>
        </label>
        <span
            v-if="error.has('option') && verifyValidate"
            class="invalid-feedback"
            style="display: block;"
        >
            {{ $t('exercise.validate.check_error') }}
        </span>
    </fieldset>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

import hoverEffect from '../../../../mixins/hoverEffect';

export default {
    name: 'ExerciseSingleAnswer',
    mixins: [hoverEffect],
    data() {
        return {
            answers: [],
            model: '',
            rightQuestion: {
                'background-color': '#f5f5f5',
                'box-shadow': '0 0 0 3px #336e2f !important',
            },
            WrongQuestion: {
                'background-color': '#f5f5f5',
                'box-shadow': '0 0 0 3px #851818 !important',
            },
            error: this.$validator.errors,
        };
    },
    props: {
        isFinished: Boolean,
        verifyValidate: Boolean,
        question: {
            type: Object,
            required: true,
        },
        index: {
            type: Number,
            required: true,
        },

    },

    computed: mapGetters({
        exercise: 'CLASS_EXERCISE',
        color: 'COLOR',
    }),

    watch: {
        question(newVal) {
            this.model = newVal.answer;
        },
    },

    methods: {
        isDisabled(id) {
            return this.isFinished;
        },

        visualFeedback(option) {
            const showAnswer = this.exercise.show_answer;

            if (showAnswer && option.correct) {
                return this.rightQuestion;
            } else if (showAnswer && !option.correct && option.id === this.model) {
                return this.WrongQuestion;
            }
        },

        async submitOption() {
            const response = await this.$store.dispatch('CLASS_EXERCISE_SUBMIT_OPTION', {
                questionId: this.question.id,
                answer: this.model
            })

            if (response === undefined) {
                this.model = '';
                this.$notify({
                    type: 'danger',
                    message: this.$t('content.exercise.error.no_connection'),
                });
            }
        },
    },
    mounted() {
        const answer = this.question.answer;
        if (answer) this.model = answer;
    },
};
</script>
<style>
a.verifyValidate{
    border-radius: 5px;
    border: 2px solid red;
}
</style>
